/**
 * @generated SignedSource<<8286f522fb0253ec85aa3f2072aa7129>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleCommentsTriggerArticle$data = {
  readonly commentCount: number | null;
  readonly " $fragmentType": "articleCommentsTriggerArticle";
};
export type articleCommentsTriggerArticle$key = {
  readonly " $data"?: articleCommentsTriggerArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleCommentsTriggerArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleCommentsTriggerArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commentCount",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "e0d5c5368a7b80574a6efccc1a4730af";

export default node;
